import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { googleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        await googleSession(sessionId);
        // Honor the edition the user picked on LoginPage.
        const preferred = localStorage.getItem("preferred_edition") || "boat";
        // Check if the user already has an active boat/household of the
        // right kind — if so land on its dashboard. Otherwise guide them
        // to /boats to create their first one.
        let targetPath = "/";
        try {
          const res = await api.getActiveBoat();
          const kind = res.data?.kind;
          if (preferred === "household") {
            targetPath = kind === "household" ? "/home" : "/boats";
          } else {
            targetPath = kind === "boat" ? "/" : "/boats";
          }
        } catch {
          // No active boat/household yet → onboard via /boats
          targetPath = "/boats";
        }
        navigate(targetPath, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-navy-800 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-sm text-stone-500">Logger inn med Google...</p>
      </div>
    </div>
  );
}
